import './style.scss';
import domReady from '@wordpress/dom-ready';
import { addFilter } from '@wordpress/hooks';
import List from '../../components/List';
import Details from '../../components/Details';

domReady( () => {
    addFilter(
        'dokan-admin-dashboard-routes',
        'dokan-add-vendor-support-admin-menu',
        function ( routes ) {
            routes.push( {
                id: 'vendor-support',
                element: <List />,
                path: '/vendor-support',
            } );
            routes.push( {
                id: 'vendor-support-details',
                element: <Details />,
                path: '/vendor-support/:id',
            } );
            return routes;
        }
    );
} );
